import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import { getActiveSection, getStudioParams } from '../../selectors/studio';
import { Props } from './StudioSearchBar';

export type StateProps = Pick<Props, 'initialValue' | 'activeSection' | 'studioParams'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  initialValue: getStudioParams(state).searchQuery,
  activeSection: getActiveSection(state),
  studioParams: getStudioParams(state),
});

export default connect(mapStateToProps);
